import { cx } from '../internal/cx';

export type SpinnerProps = {
  size?: 'sm' | 'md' | 'lg';
  /** Texte lu par les lecteurs d'écran. */
  label?: string;
  className?: string;
};

const SIZES: Record<NonNullable<SpinnerProps['size']>, string> = {
  sm: 'h-4 w-4 border-2',
  md: 'h-6 w-6 border-[3px]',
  lg: 'h-9 w-9 border-4',
};

/**
 * Indicateur de chargement (`role="status"` + texte SR).
 * L'anneau reste visible même figé (kill-switch reduced-motion global).
 */
export function Spinner({ size = 'md', label = 'Chargement…', className }: SpinnerProps) {
  return (
    <span role="status" className={cx('inline-flex items-center justify-center', className)}>
      <span
        aria-hidden="true"
        className={cx(
          'inline-block animate-spin rounded-full border-current border-t-transparent',
          SIZES[size],
        )}
      />
      <span className="sr-only">{label}</span>
    </span>
  );
}
